import { CURRENCIES } from '@/settings/data-mappings/constants/constants';
import { i18n_t as $t } from '@/utils/i18n';

export function formatNumberWithCurrency (value, currency = 'USD') {
    if (!value || value === $t('N/A')) {
        return $t('N/A');
    }

    const currencyConfig = CURRENCIES[currency];
    const { id, numberCode } = currencyConfig;
    const options = {
        style: 'currency',
        currency: id,
        notation: 'compact',
        maximumSignificantDigits: 3,
    };

    return new Intl.NumberFormat(numberCode, options).format(value);
}
